<script>
  import logoIcon from './assets/logo.svg'
</script>

{@html logoIcon}
